import { motion } from "framer-motion"
import { Briefcase, Gavel, Sparkles, Coffee, Laptop, BookOpen, GraduationCap } from "lucide-react"
import "./WorkOpportunities.css"

const WorkOpportunities = ({ countryData }) => {
  const work = countryData?.workOpportunities || {}
  const { intro = "", options = [], jobs = [], regulations = [] } = work

  const jobIcons = [Coffee, Laptop, BookOpen, GraduationCap, Sparkles]

  return (
    <div className="work-opportunities-container">
      <motion.h1
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
      >
        Career & Work Opportunities {countryData?.name}
      </motion.h1>

      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.2 }}
        viewport={{ once: true }}
        className="work-intro"
      >
        {intro || `Explore various part-time and post-study work options in ${countryData?.name}. Balance your studies with professional experience.`}
      </motion.p>

      <div className="work-options-grid">
        {options.map((opt, idx) => (
          <motion.div
            key={idx}
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ delay: idx * 0.1 }}
            viewport={{ once: true }}
            className="work-option-card"
          >
            <h2>{opt.title}</h2>
            <p>{opt.description}</p>
          </motion.div>
        ))}
      </div>

      <div className="popular-jobs-section">
        <h2><Briefcase size={24} color="#06b6d4" style={{ verticalAlign: 'middle', marginRight: '12px' }} /> Popular Student Roles</h2>
        <div className="jobs-grid">
          {jobs.map((job, idx) => {
            const Icon = jobIcons[idx % jobIcons.length]
            return (
              <motion.div
                key={idx}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: idx * 0.1 }}
                viewport={{ once: true }}
                className="job-card"
              >
                <div className="job-icon">
                  <Icon size={24} />
                </div>
                <h3>{job.title}</h3>
                <p className="job-pay">{job.pay}</p>
                <p className="job-desc">{job.description}</p>
              </motion.div>
            )
          })}
        </div>
      </div>

      <div className="work-regulations-section">
        <h2><Gavel size={24} color="#fbbf24" style={{ verticalAlign: 'middle', marginRight: '12px' }} /> Work Regulations</h2>
        <div className="regulations-grid">
          {regulations.map((rule, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, x: idx % 2 === 0 ? -20 : 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="regulation-card"
            >
              <h3>{rule.title}</h3>
              <ul>
                {(rule.points || "").split(". ").map((point, i) =>
                  point.trim() ? <li key={i}>{point.trim()}</li> : null
                )}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default WorkOpportunities
